import { createFileRoute } from "@tanstack/react-router";

import TodosDuplicates from "@/features/todos/todos-duplicates";

export const Route = createFileRoute(
  "/_authenticated/$company/buchhaltung/ausgang/duplicates",
)({
  component: ReceivableDuplicatesPage,
  staticData: {
    breadcrumb: ["todos.receivable.title"],
  },
});

function ReceivableDuplicatesPage() {
  return <TodosDuplicates type="receivable" />;
}
